import { MARKET_BY_URL } from "Market/Api/Query/useMarketByIdQuery";
import { RegionsBaseForm } from "Market/Components/Form/RegionsBaseForm";
import { useQueryClient } from "@tanstack/react-query";
import type { FC } from "react";

type Props = {
	marketId: number;
	urlPath: string;
};

export const RegionCardCreateWidget: FC<Props> = ({ marketId, urlPath }) => {
	const queryClient = useQueryClient();

	const handleSuccessResponse = () => {
		queryClient.invalidateQueries({ queryKey: [MARKET_BY_URL, urlPath] });
	};

	return (
		<RegionsBaseForm marketId={marketId} onSuccess={handleSuccessResponse} />
	);
};
